"use strict";

require("core-js/modules/es.object.assign.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.TableBody = void 0;
require("core-js/modules/es.symbol.description.js");
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _TableProps = require("../TableProps");
var _TableCellContents = require("../TableCells/TableCellContents");
var _RowEditingControls = require("./RowEditingControls");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
const TableBody = _ref => {
  let {
    isEditable = false,
    hookFormMethods,
    inlineEditing,
    showRowEditingControls,
    tableInstance,
    onDelete = () => {},
    onSave = () => {},
    onEdit = () => {}
  } = _ref;
  if (!tableInstance) {
    return null;
  }
  const {
    getTableBodyProps,
    page,
    prepareRow
  } = tableInstance;
  const HandleDelete = _ref2 => {
    let {
      row
    } = _ref2;
    onDelete(row);
  };
  const HandleSave = _ref3 => {
    let {
      row
    } = _ref3;
    onSave(row);
  };
  const HandleEdit = details => {
    // Row will include { index, id, newValue }
    onEdit(details);
  };
  const isLastCell = (row, cellIndex) => {
    return cellIndex === row.cells.length - 1;
  };
  const isEditableControlsCell = (row, cellIndex) => {
    return showRowEditingControls && isLastCell(row, cellIndex);
  };
  const getCellCssClass = (row, cell, cellIndex) => {
    const {
      cssClass = ''
    } = cell.column;
    return "".concat(cssClass, " ").concat(isEditableControlsCell(row, cellIndex) ? 'editableControlsCell' : '');
  };
  return /*#__PURE__*/_react.default.createElement("tbody", getTableBodyProps(), page.map(row => {
    prepareRow(row);
    return /*#__PURE__*/_react.default.createElement("tr", _extends({
      key: "tableBodyRow_".concat(row.id)
    }, row.getRowProps()), row.cells.map((cell, cellIndex) => /*#__PURE__*/_react.default.createElement("td", _extends({
      key: "tableBodyCell_".concat(cell.id)
    }, cell.getCellProps(), {
      className: getCellCssClass(row, cell, cellIndex)
    }), /*#__PURE__*/_react.default.createElement("div", {
      className: "tableCellContents"
    }, /*#__PURE__*/_react.default.createElement(_TableCellContents.TableCellContents, {
      cell: cell,
      row: row,
      isEditable: isEditable,
      inlineEditing: inlineEditing,
      onEdit: props => HandleEdit(_objectSpread(_objectSpread({}, props), {}, {
        row
      })),
      tableInstance: tableInstance,
      hookFormMethods: hookFormMethods
    }), showRowEditingControls && isLastCell(row, cellIndex) && /*#__PURE__*/_react.default.createElement(_RowEditingControls.RowEditingControls, {
      row: row,
      onDelete: () => HandleDelete(row),
      onEdit: props => HandleEdit(_objectSpread(_objectSpread({}, props), {}, {
        row
      }))
    })))));
  }));
};
exports.TableBody = TableBody;
TableBody.propTypes = {
  tableInstance: _propTypes.default.shape(_TableProps.TableStateProps),
  isEditable: _propTypes.default.bool,
  inlineEditing: _propTypes.default.bool,
  showRowEditingControls: _propTypes.default.bool,
  onDelete: _propTypes.default.func,
  onSave: _propTypes.default.func,
  onEdit: _propTypes.default.func,
  // eslint-disable-next-line react/forbid-prop-types
  hookFormMethods: _propTypes.default.any
};